import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Slide,
  Card,
  Grow,
  Avatar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../../assets/img/logo.jpeg";
import FacebookIcon from "@mui/icons-material/Facebook";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import EmailIcon from "@mui/icons-material/Email";

// Animación
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ModalInicioHome = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const yaMostrado = sessionStorage.getItem("modalInicioMostrado");
    if (!yaMostrado) {
      setOpen(true);
      sessionStorage.setItem("modalInicioMostrado", "true");
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: "95%", sm: "85%", md: "500px" },
          minHeight: { xs: "auto", md: "400px" },
          maxHeight: "90vh",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.25)",
          background: "linear-gradient(135deg, #fdfdfd 0%, #eef5ff 100%)",
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          py: { xs: 2, md: 2.5 },
          textAlign: "center",
          fontWeight: "bold",
          fontSize: { xs: "1rem", sm: "1.2rem", md: "1.4rem" },
          background: "linear-gradient(90deg, #1e88e5, #1565c0)",
          color: "white",
        }}
      >
        Subgerencia de Artesanía y Turismo

        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 10,
            top: 10,
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: { xs: 2, md: 3 } }}>
        {/* LOGO */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Grow in={open} timeout={800}>
            <Box
              sx={{
                width: { xs: "90%", sm: "70%", md: 400 },
                height: { xs: 60, sm: 70, md: 80 },
                mx: "auto",
                borderRadius: "10%",
                overflow: "hidden",
                border: "3px solid #42a5f5",
                boxShadow: "0px 8px 20px rgba(0,0,0,0.25)",
              }}
            >
              <img
                src={Logo}
                alt="Logo"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            </Box>
          </Grow>
        </Box>

        {/* CONTACTOS */}
        <Box sx={{ display: "grid", gap: { xs: 1, md: 1.5 } }}>
          {[
            {
              icon: <PhoneAndroidIcon />,
              title: "Número de Celular",
              info: "987 412 563",
            },
            {
              icon: <FacebookIcon />,
              title: "Facebook",
              info: "Subgerencia de Artesanía y Turismo",
            },
            {
              icon: <EmailIcon />,
              title: "Correo Electrónico",
              info: "sanroman_artesaniayturismo@gmail.com",
            },
          ].map((item, i) => (
            <Grow in={open} key={i} timeout={600 + i * 200}>
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 1.2, md: 2 },
                  borderRadius: "14px",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.12)",
                  p: { xs: 1, md: 1.2 },
                  transition: "0.3s",
                }}
              >
                <Avatar
                  sx={{
                    bgcolor: "#1e88e5",
                    width: { xs: 32, md: 40 },
                    height: { xs: 32, md: 40 },
                  }}
                >
                  {item.icon}
                </Avatar>

                <Box>
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#0d47a1",
                      fontSize: { xs: "0.85rem", md: "1rem" },
                    }}
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.75rem", md: "0.9rem" },
                      color: "text.secondary",
                    }}
                  >
                    {item.info}
                  </Typography>
                </Box>
              </Card>
            </Grow>
          ))}
        </Box>

        {/* FRASE */}
        <Box
          sx={{
            mt: 3,
            textAlign: "center",
            py: { xs: 1, md: 1.2 },
            borderRadius: "10px",
            background: "linear-gradient(90deg, #42a5f5, #1e88e5)",
            color: "white",
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.8rem", md: "0.95rem" },
            }}
          >
            «Impulsando el turismo en la Provincia de San Román»
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalInicioHome;